/* istanbul ignore file */
import React from 'react';

import LeaveStatusDropdown from 'domain/people/leave/shared/input/LeaveStatusDropdown';
import { DropDownFilterProps, DropDownFilter } from 'framework/list';

const LeaveStatusFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <LeaveStatusDropdown {...props} />
    </DropDownFilter>
  );
};

export default LeaveStatusFilter;
